import LogoSvg from "images/main/logo.inline.svg";
import * as React from 'react';
export default {
  LogoSvg,
  React
};